import * as S from "./style";

const SubscribeSection = () => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };

  return (
    <S.SectionRoot>
      <S.SectionInner>
        <S.Title>Join To VIP Resale</S.Title>

        <S.Form onSubmit={handleSubmit}>
          <S.Input type="email" placeholder="E-mail" />
          <S.SubmitButton type="submit">Підписатись</S.SubmitButton>
        </S.Form>
      </S.SectionInner>
    </S.SectionRoot>
  );
};

export default SubscribeSection;
